import React, { useState, useEffect, useRef } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";

import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Loader2 from "../../Components/Loader/loader2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import CamperService from "../../Api/services/CamperService";

import { NumericFormat } from 'react-number-format';
import "react-datepicker/dist/react-datepicker.css";
import Vanlife from "../../Components/Vanlife/Vanlife";
import { t } from 'i18next';
import { useTranslation } from "react-i18next";
const Campersubscription = () => {
    const { i18n, t } = useTranslation();
  
  const viewcamper = useRef(null);
  const CustomArrow = ({ onClick, direction }) => (
    <div className="custom-btn-group">
      <button className={`custom-arrow ${direction}`} onClick={onClick}>
        {direction === 'prev' ? '<' : '>'}
      </button>
    </div>
  );
  var imageUrl = process.env.REACT_APP_LARAVEL_CAMPER_IMAGE_URL;

  const [price, setPrice] = useState([]);
  const [imageloader, setImageLoader] = useState(true);

  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate();
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);

  const params = { location: searchParams.get('location') };
  const [Camper, setCamper] = useState([]);
  useEffect(() => {


    getPrice();


    getCamper();
  }, []);
  const getCamper = async () => {
    try {
      let camperList = await CamperService.index().json();

      var responsedata = camperList.data.filter(function (item) {
        return item.camper_type_id == 2 && item.status == 1;
      });

      setCamper(responsedata);
      setImageLoader(false);


    } catch (error) {
      console.log(error);
    }
  };

  const getPrice = async () => {
    try {
      let priceList = await CamperService.subIndex().json();

      setPrice(priceList.data);
    } catch (error) {
      console.log(error);
    }
  };



  const settingsMain = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: nav2,
    draggable: false,
    touchThreshold: 0,
    adaptiveHeight: true,
  };

  const settingsThumbs = {
    slidesToShow: 2,
    slidesToScroll: 1,
    asNavFor: nav1,
    dots: true,
    centerMode: true,
    swipeToSlide: true,
    focusOnSelect: true,
    centerPadding: "10px",
    arrows: true,
  };


  var fiverow = {
    dots: false,
    prevArrow: <CustomArrow direction="prev" />,
    nextArrow: <CustomArrow direction="next" />,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1273,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          prevArrow: <CustomArrow direction="prev" />,
          nextArrow: <CustomArrow direction="next" />,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          prevArrow: <CustomArrow direction="prev" />,
          nextArrow: <CustomArrow direction="next" />,

        },
      },
      {
        breakpoint: 600,
        settings: {
          prevArrow: <CustomArrow direction="prev" />,
          nextArrow: <CustomArrow direction="next" />,
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: <CustomArrow direction="prev" />,
          nextArrow: <CustomArrow direction="next" />,
          dots: false,
        },
      },
      {
        breakpoint: 480,

        settings: {
          dots: true,
          slidesToShow: 1,

        },
      },
    ],
  };
  var fourrow = {
    prevArrow: <CustomArrow direction="prev" />,
    nextArrow: <CustomArrow direction="next" />,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1273,
        settings: {
          prevArrow: <CustomArrow direction="prev" />,
          nextArrow: <CustomArrow direction="next" />,
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,

        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,

        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,

        },
      },
    ],
  };



  return (
    <>
      <Header />

      <div className="min-h-screen bg-off-white">
        <div className="text-center">
          <div className="overflow-hidden">
            <div className="-ml-[5%] w-[110%] overflow-hidden rounded-b-[60%20%] px-[5%]">
              <div className="relative">
                <div className="overflow-hidden">
                  <img
                    src="/title-images/Subscription-page-new.jpg"
                    alt="camper-subscription-banner"
                    className="absolute max-h-full w-full scale-110 object-cover blur-lg dark:brightness-90 sm:aspect-hero-regular 3xl:aspect-hero-long aspect-square"
                  />
                </div>
                <picture className="flex max-h-[60vh] w-full text-0">
                  <img
                    className="z-0 max-h-full w-full object-cover dark:brightness-90 sm:aspect-hero-regular 3xl:aspect-hero-long aspect-square"
                    src="/title-images/Subscription-page-new.jpg"
                    alt="camper-subscription-banner"
                    width="2552"
                    height="1286"
                  />
                </picture>
                <div className="absolute top-0 left-0 flex h-full w-full flex-col items-center justify-end">
                  <div className="pb-12 2xl:pb-14 w-full bg-gradient-to-t from-black-pure/80 to-transparent pt-20 md:pt-14 xl:pt-32">
                    <h1 className="whitespace-pre-line break-words m-auto max-w-4xl px-8 text-xl md:text-2xl text-white drop-shadow-text dark:text-off-white xs:text-2xl xl:text-3xl mb-5 md:mb-8 xl:mb-12">
                      {t("subscription.Camper Subscription")}
                    </h1>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="inline-block align-top dark:cssvar-white-to-off-white dark:cssvar-secondary-to-secondary dark:cssvar-primary-to-primary-dark relative mx-auto -mt-12 child:h-24 child:w-24 2xl:-mt-14 2xl:child:h-28 2xl:child:w-28">
            <img
              className=""
              src="/Images/camper-subscription-hero.svg"
              alt="camper-subscription-hero"
            />
          </div>
        </div>

        <div className="md:mx-5 mx-0 max-w-screen-xl xl-padded:mx-auto">
          <div className="pt-4 2xl:pt-8 pb-0 md:mx-auto mx-4 flex max-w-3xl flex-col items-center text-center">
            <p className="mb-4 whitespace-pre-line text-md price-font">
              {t("subscription.Starting at Only 499€/Month")}
            </p>
            <h2 className="whitespace-pre-line break-words text-xl md:text-2xl mb-5">
              {t("subscription.RV Adventure Pass")}
            </h2>
            <p className="whitespace-pre-line text-2md font-normal md:text-lg-paragraph md:font-normal text-20">
              {/* {t("subscription.Dreaming of hitting the open road during your parental leave, sabbatical, or while embracing the  digital nomad lifestyle? Secure your home-on-wheels for a flat monthly fee, whether it's for a  couple of months or an entire year. One simple price covers it all")}. */}
              {t("subscription.Dreaming of hitting the open road during your parental leave, sabbatical, or while embracing the  digital nomad lifestyle?")}<br />{t("subscription.Secure your home-on-wheels for a flat monthly fee, whether it's for a  couple of months or an entire year.")}<br />{t("subscription.One simple price covers it all")}.
            </p>
          </div>

          <div className="">
            <div className="pt-8 2xl:pt-12 pb-0 step-slider">
              <div className="mx-5 max-w-screen-xl xl-padded:mx-auto">
                <Slider className="camper-slider" {...fiverow}>

                  <div className="orange-border text-white rounded bg-primary p-6 shadow dark:bg-off-black-desat dark:shadow-dark 2xs:rounded-lg group/parent mt-12 flex h-[calc(100%-3rem)] flex-col items-center overflow-visible px-6 2xl:mt-14 2xl:h-[calc(100%-3.5rem)] pt-0 pb-7">
                    <div className="flex justify-center align-top dark:cssvar-white-to-off-white dark:cssvar-secondary-to-secondary dark:cssvar-primary-to-primary-dark -mt-12 mb-5 child:h-24 child:w-24 2xl:-mt-14 2xl:child:h-28 2xl:child:w-28">
                      <img
                        src="/Images/img-services-svg-4.svg"
                        alt="services-icon"
                      />
                    </div>
                    <h3 className="mb-3 whitespace-pre-line text-center text-lg">
                      {t("subscription.Travel with Ease!")}
                    </h3>
                    <p className="whitespace-pre-line text-center">
                      {t("subscription.Comprehensive insurance, taxes, and maintenance costs are already included.")}
                    </p>
                  </div>


                  <div className="orange-border text-white rounded bg-primary p-6 shadow dark:bg-off-black-desat dark:shadow-dark 2xs:rounded-lg group/parent mt-12 flex h-[calc(100%-3rem)] flex-col items-center overflow-visible px-6 2xl:mt-14 2xl:h-[calc(100%-3.5rem)] pt-0 pb-7">
                    <div className="flex justify-center align-top dark:cssvar-white-to-off-white dark:cssvar-secondary-to-secondary dark:cssvar-primary-to-primary-dark -mt-12 mb-5 child:h-24 child:w-24 2xl:-mt-14 2xl:child:h-28 2xl:child:w-28">
                      <img
                        src="/Images/calander-icon.svg"
                        alt="calander-icon"
                      />
                    </div>
                    <h3 className="mb-3 whitespace-pre-line text-center text-lg">
                      {t("subscription.Adventures from")}&nbsp;<span className="price-font">2</span> {t("subscription.Months")}
                    </h3>
                    <p className="whitespace-pre-line text-center">
                      {t("subscription.Explore Europe for up to a year with 2,000 free kilometers per month included, and book additional  kilometers as needed")}
                    </p>
                  </div>




                  <div className="orange-border text-white rounded bg-primary p-6 shadow dark:bg-off-black-desat dark:shadow-dark 2xs:rounded-lg group/parent mt-12 flex h-[calc(100%-3rem)] flex-col items-center overflow-visible px-6 2xl:mt-14 2xl:h-[calc(100%-3.5rem)] pt-0 pb-7">
                    <div className="flex justify-center align-top dark:cssvar-white-to-off-white dark:cssvar-secondary-to-secondary dark:cssvar-primary-to-primary-dark -mt-12 mb-5 child:h-24 child:w-24 2xl:-mt-14 2xl:child:h-28 2xl:child:w-28">
                      <img
                        src="/Images/img-services-svg.svg"
                        alt="services-icon"
                      />
                    </div>
                    <h3 className="mb-3 whitespace-pre-line text-center text-lg">
                      {t("subscription.Our Commitment to Service")}:
                    </h3>
                    <p className="whitespace-pre-line text-center">
                      {t("subscription.As passionate campers ourselves, we're here for you anytime, ready to share our expertise")}.
                    </p>
                  </div>


                  <div className="orange-border text-white rounded bg-primary p-6 shadow dark:bg-off-black-desat dark:shadow-dark 2xs:rounded-lg group/parent mt-12 flex h-[calc(100%-3rem)] flex-col items-center overflow-visible px-6 2xl:mt-14 2xl:h-[calc(100%-3.5rem)] pt-0 pb-7">
                    <div className="flex justify-center align-top dark:cssvar-white-to-off-white dark:cssvar-secondary-to-secondary dark:cssvar-primary-to-primary-dark -mt-12 mb-5 child:h-24 child:w-24 2xl:-mt-14 2xl:child:h-28 2xl:child:w-28">
                      <img src="/Images/img-sales-icon.svg" alt="services-icon" />
                    </div>
                    <h3 className="mb-3 whitespace-pre-line text-center text-lg">
                      {t("subscription.Instantly Ready to Go!")}
                    </h3>
                    <p className="whitespace-pre-line text-center">
                      {t("subscription.Our Ready-to-Go package includes camping gear, a fully equipped kitchen, as well as a table and  chairs that we deliver directly to you. And more add-ons available!")}
                    </p>
                  </div>

                  <div className="orange-border text-white rounded bg-primary p-6 shadow dark:bg-off-black-desat dark:shadow-dark 2xs:rounded-lg group/parent mt-12 flex h-[calc(100%-3rem)] flex-col items-center overflow-visible px-6 2xl:mt-14 2xl:h-[calc(100%-3.5rem)] pt-0 pb-7">
                    <div className="flex justify-center align-top dark:cssvar-white-to-off-white dark:cssvar-secondary-to-secondary dark:cssvar-primary-to-primary-dark -mt-12 mb-5 child:h-24 child:w-24 2xl:-mt-14 2xl:child:h-28 2xl:child:w-28">
                      <img
                        src="/Images/img-percentage-icon.svg"
                        alt="kilometers-svg"
                      />
                    </div>
                    <h3 className="mb-3 whitespace-pre-line text-center text-lg">
                      {t("subscription.Fair Prices!")}
                    </h3>
                    <p className="whitespace-pre-line text-center">
                      {t("subscription.Our prices are as fair as the weather. Monthly fixed rates, depending on the season")}.
                    </p>
                  </div>




                </Slider>
              </div>
            </div>
          </div>
          <div ref={viewcamper} className="md:mx-0 mx-4 md:pt-14 pb-0 md:mx-auto flex max-w-4xl flex-col items-center text-center" id="book-your-campor">
            <p className="mb-4 whitespace-pre-line text-md mt-sm-5">{t("subscription.Camper Subscription Models")}</p>
            <h2 className="whitespace-pre-line break-words text-xl md:text-2xl mb-6">{t("subscription.No matter your choice - every option is perfect!")}</h2>
            <p className="mb-4 whitespace-pre-line text-2md font-normal md:text-lg-paragraph md:font-normal text-20">
              {t("subscription.Whether it's a campervan, travel van, motorhome or caravan - there's no wrong choice with us.  With each of our models, you set off worry-free towards adventure")}.
            </p>
          </div>

          <div className="mx-5 max-w-screen-xl xl-padded:mx-auto pb-4 2xl:pb-8 camper-sale-slider">
            <div className="pt-0 pb-8 2xl:pb-12 grid gap-x-5 sm:grid-cols-2 lg:grid-cols-3 justify-center sale-overview">

              {Camper.map((item, index) => (
                <div className="relative flex flex-col mt-6 text-gray-700 bg-white shadow-md bg-clip-border rounded-xl mt-[50%] hover-bg">
                  {
                    imageloader ? <Loader2 /> :
                      <>
                        <Link
                          to={`/camper-subscription/${item.id}?location=1&pickup=14&return=11`}
                          className="box-border h-full max-w-5xl pt-[60%]"
                        >
                          <div
                            className="relative  mx-4 text-white  -mt-[60%] bg-clip-border rounded-xl bg-blue-gray-500 shadow-blue-gray-500/40 camper-divImg">
                            <picture className="text-0">
                              <img
                                className="box-img inline-block max-w-full object-cover dark:brightness-90 aspect-[1.5] w-full  group-hover:scale-105 transition-all duration-300 divImg -mt-[50%]"
                                height={item.image ? 100 : 0}
                                width={item.image ? 100 : 0}
                                src={'/Images/img-0.gif'}
                                style={{ backgroundImage: "url(" + imageUrl + item.image + ")" }}
                                //  src={imageUrl + item.image}

                                alt="rent-img-one"
                              />

                            </picture>
                          </div>
                          <div className="xl:p-0 p-0">
                            <h5 className="mb-2 text-xl xs:mb-6 price-font fw-600 text-center tracking-wide text-orange">
                              {item.title}
                            </h5>
                            {Camper[index].camper_details.map((camper_details) => {
                              return (
                                <>
                                  <h4 className="block mb-2 text-md  font-semibold leading-snug tracking-normal text-blue-gray-900 text-center title-camper">{camper_details.sub_title}</h4>

                                </>
                              )
                            })}




                            <h4 className="block text-center text-md">
                              {t("subscription.from")}{" "}
                              <span className='price-font text-md inline-block align-bottom'>

                                <NumericFormat
                                  value={item.campernew_price}
                                  thousandSeparator={'.'}
                                  decimalSeparator={','}
                                  displayType={'text'}

                                />

                                €
                              </span>
                              <p className="text-md inline-block align-bottom">&nbsp;{t("Rent.per Month")}</p>
                            </h4>
                          </div>
                          <div>
                            <div className="mt-4 mb-1  bg-off-white p-3 dark:bg-black px-8">
                              {Camper[index].feature.map((feature) => {
                                return (
                                  <div className="mb-2 flex last:mb-0">
                                    <div className="flex items-center justify-center self-start rounded-full bg-white p-1 dark:bg-off-white">
                                      <div className=" rounded-full bg-white inline-block align-top child:h-5 child:w-5 xs:child:h-6 xs:child:w-6 sm:child:h-5 sm:child:w-5 2md:child:h-6 2md:child:w-6 lg:child:h-5 lg:child:w-5 xl-padded-with-arrows:child:h-6 xl-padded-with-arrows:child:w-6">
                                        <img src={process.env.REACT_APP_LARAVEL_FEATURE_IMAGE_URL + feature.icon} width="24px" height="24px" className="rounded-full bg-white" />

                                      </div>
                                    </div>
                                    <p className="mt-1 ml-2 text-sm xs:text-sm sm:text-xs 2md:text-sm lg:text-xs xl-padded-with-arrows:text-sm">
                                      {feature.title}
                                    </p>
                                  </div>
                                );
                              })}

                            </div>


                          </div>
                        </Link>
                      </>
                  }
                  <div className="p-6 pt-0">
                    <div className="mt-4">



                      <Link
                        className="hover-border mt-4 group/button block disabled:opacity-50 rounded text-md dark:text-off-white p-3 pl-5 transition-all shadow dark:shadow-dark hover:shadow-elevated dark:hover:shadow-dark-elevated text-off-black bg-transparent border hover:border-secondary group-hover/parent:border-secondary hover:bg-transparent group-hover/parent:bg-transparent dark:bg-transparent dark:hover:bg-transparent dark:group-hover/parent:bg-transparent dark:hover:text-off-white dark:group-hover/parent:text-off-white dark:hover:border-off-white dark:group-hover/parent:border-off-white mb-4 group-hover:border-secondary dark:group-hover:border-off-white"

                        to={`/subscriptiondetail/${item.id}?location=1&pickup=14&return=11`}
                      >
                        <div className="flex h-full items-center justify-between">
                          <span className="flex">{t("subscription.Book now")}</span>
                          <div className="inline-block align-top min-w-max child:h-6 child:w-6 dark:cssvar-secondary-to-off-black ml-2  dark:group-hover/button:cssvar-secondary-to-off-black dark:group-hover/parent:cssvar-secondary-to-off-black">
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g fill="none" fillRule="evenodd">
                                <path
                                  d="m22.126 16-7.647-7.647a1.207 1.207 0 0 0-1.705 0l-.42.42a1.204 1.204 0 0 0 0 1.705L17.876 16l-5.522 5.522a1.203 1.203 0 0 0 0 1.704l.42.422c.47.47 1.235.469 1.705-.002L22.126 16z"
                                  fill="var(--svg-color-secondary, #163435)"
                                ></path>
                              </g>
                            </svg>
                          </div>
                        </div>
                      </Link>


                      <Link
                        className="mt-4 group/button block disabled:opacity-50 border border-transparent rounded text-md text-white dark:text-off-white bg-primary dark:bg-primary-dark p-3 pl-5 hover:bg-secondary group-hover/parent:bg-secondary dark:hover:text-off-black dark:group-hover/parent:text-off-black dark:hover:bg-off-white dark:group-hover/parent:bg-off-white transition-all shadow dark:shadow-dark hover:shadow-elevated dark:hover:shadow-dark-elevated w-full"

                        to={`/camper-subscription/${item.id}?location=1&pickup=14&return=11`}
                      >
                        <div className="flex h-full items-center justify-between">
                          <span className="flex">{t("Rent.Availability & info")}</span>
                          <div className="inline-block align-top min-w-max child:h-6 child:w-6 dark:cssvar-secondary-to-off-white ml-2 cssvar-secondary-to-secondary">
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g fill="none" fillRule="evenodd">
                                <path
                                  d="m22.126 16-7.647-7.647a1.207 1.207 0 0 0-1.705 0l-.42.42a1.204 1.204 0 0 0 0 1.705L17.876 16l-5.522 5.522a1.203 1.203 0 0 0 0 1.704l.42.422c.47.47 1.235.469 1.705-.002L22.126 16z"
                                  fill="var(--svg-color-secondary, #fff)"
                                ></path>
                              </g>
                            </svg>
                          </div>
                        </div>
                      </Link>

                    </div>
                  </div>

                </div>
              ))}

            </div>
          </div>
        </div>

        <div className="mx-5 max-w-screen-xl xl-padded:mx-auto bg-primary rounded-lg px-8">
          <div className="pt-8 2xl:pt-12 pb-0 mx-auto flex max-w-3xl flex-col items-center text-center">
            <h2 className="whitespace-pre-line break-words text-xl md:text-2xl text-white text-orange">
              {t("subscription.How to book the Camper Subscription")}
            </h2>
          </div>



          <div className="pt-3 md:pb-8 pb-3 2xl:pb-4 orange-nav">
            <div className="">
              <div className="md:mx-5 max-w-screen-xl xl-padded:mx-auto pt-5 pb-8 step-slider">
                <Slider className="camper-slider arrow-white" {...fourrow}>

                  <div className="subcription-box rounded bg-white p-6 shadow dark:bg-off-black-desat dark:shadow-dark 2xs:rounded-lg group/parent mt-12 flex h-[calc(100%-3rem)] flex-col items-center overflow-visible px-6 2xl:mt-14 2xl:h-[calc(100%-3.5rem)] pt-0 pb-5">
                    <div className="flex justify-center align-top dark:cssvar-white-to-off-white dark:cssvar-secondary-to-secondary dark:cssvar-primary-to-primary-dark -mt-12 mb-5 child:h-24 child:w-24 2xl:-mt-14 2xl:child:h-28 2xl:child:w-28">
                      <img
                        src="/Images/img-services-svg-2.svg"
                        alt="services-icon"
                      />
                    </div>
                    <h3 className="mb-3 whitespace-pre-line text-center text-lg">
                      <span className='price-font'>1.</span> {t("subscription.Choose Your Camper")}
                    </h3>
                    <p className="whitespace-pre-line text-center">
                      {t("subscription.Select the camper that suits you and your needs best. Many are available right away!")}
                    </p>
                    <Link
                      onClick={() =>
                        window.scrollTo({
                          top: viewcamper.current.offsetTop - 118,
                          behavior: "smooth",
                        })
                      }
                      className="mt-4 w-full group/button disabled:opacity-50 border border-transparent rounded text-md text-white dark:text-off-white bg-primary dark:bg-primary-dark p-3 hover:bg-secondary group-hover/parent:bg-secondary dark:hover:text-off-black dark:group-hover/parent:text-off-black dark:hover:bg-off-white dark:group-hover/parent:bg-off-white transition-all shadow dark:shadow-dark hover:shadow-elevated dark:hover:shadow-dark-elevated pl-3 py-2 inline-block">
                      <div className="flex h-full items-center">

                        <span className="flex small-text">{t("subscription.View Camper")}</span>
                        <div className="inline-block align-top min-w-max child:h-6 child:w-6 dark:cssvar-secondary-to-off-white ml-2 cssvar-secondary-to-white dark:group-hover/button:cssvar-secondary-to-off-black dark:group-hover/parent:cssvar-secondary-to-off-black ml-auto">
                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g fill="none" fillRule="evenodd">
                              <path
                                d="m22.126 16-7.647-7.647a1.207 1.207 0 0 0-1.705 0l-.42.42a1.204 1.204 0 0 0 0 1.705L17.876 16l-5.522 5.522a1.203 1.203 0 0 0 0 1.704l.42.422c.47.47 1.235.469 1.705-.002L22.126 16z"
                                fill="var(--svg-color-secondary, #163435)"
                              ></path>
                            </g>
                          </svg>
                        </div>
                      </div>
                    </Link>
                  </div>


                  <div className="subcription-box rounded bg-white p-6 shadow dark:bg-off-black-desat dark:shadow-dark 2xs:rounded-lg group/parent mt-12 flex h-[calc(100%-3rem)] flex-col items-center overflow-visible px-6 2xl:mt-14 2xl:h-[calc(100%-3.5rem)] pt-0 pb-5">
                    <div className="flex justify-center align-top dark:cssvar-white-to-off-white dark:cssvar-secondary-to-secondary dark:cssvar-primary-to-primary-dark -mt-12 mb-5 child:h-24 child:w-24 2xl:-mt-14 2xl:child:h-28 2xl:child:w-28">
                      <img src="/Images/booking-flow.svg" alt="service-icon" />
                    </div>
                    <h3 className="mb-3 whitespace-pre-line text-center text-lg">
                      <span className='price-font'>2.</span> {t("subscription.Submit Your Booking Request")}
                    </h3>
                    <p className="whitespace-pre-line text-center">
                      {t("subscription.Request your camper subscription for your desired period with commitment through our website  and choose your accessories")}.
                    </p>
                  </div>


                  <div className="subcription-box rounded bg-white p-6 shadow dark:bg-off-black-desat dark:shadow-dark 2xs:rounded-lg group/parent mt-12 flex h-[calc(100%-3rem)] flex-col items-center overflow-visible px-6 2xl:mt-14 2xl:h-[calc(100%-3.5rem)] pt-0 pb-5">
                    <div className="flex justify-center align-top dark:cssvar-white-to-off-white dark:cssvar-secondary-to-secondary dark:cssvar-primary-to-primary-dark -mt-12 mb-5 child:h-24 child:w-24 2xl:-mt-14 2xl:child:h-28 2xl:child:w-28">
                      <img
                        src="/Images/calander-icon.svg"
                        alt="calander-icon"
                      />
                    </div>
                    <h3 className="mb-3 whitespace-pre-line text-center text-lg">
                      <span className='price-font'>3.</span> {t("subscription.Receive Confirmation")}
                    </h3>
                    <p className="whitespace-pre-line text-center">
                      {t("subscription.Once we've verified all your information, you'll receive your booking confirmation with payment  details")}.
                    </p>
                  </div>


                  <div className="subcription-box rounded bg-white p-6 shadow dark:bg-off-black-desat dark:shadow-dark 2xs:rounded-lg group/parent mt-12 flex h-[calc(100%-3rem)] flex-col items-center overflow-visible px-6 2xl:mt-14 2xl:h-[calc(100%-3.5rem)] pt-0 pb-5">
                    <div className="flex justify-center align-top dark:cssvar-white-to-off-white dark:cssvar-secondary-to-secondary dark:cssvar-primary-to-primary-dark -mt-12 mb-5 child:h-24 child:w-24 2xl:-mt-14 2xl:child:h-28 2xl:child:w-28">
                      <img
                        src="/Images/Adventure.info.svg"
                        alt="services-icon"
                      />
                    </div>
                    <h3 className="mb-3 whitespace-pre-line text-center text-lg">
                      <span className='price-font'>4.</span> {t("subscription.Enjoy Freedom")}
                    </h3>
                    <p className="whitespace-pre-line text-center">
                      {t("subscription.2, 3, 6, or 12 months - you decide how long you drive your camper")}.
                    </p>
                    <Link onClick={() =>
                      window.scrollTo({
                        top: viewcamper.current.offsetTop - 118,
                        behavior: "smooth",
                      })
                    } className="mt-4 w-full group/button disabled:opacity-50 border border-transparent rounded text-white dark:text-off-white bg-primary dark:bg-primary-dark p-3 hover:bg-secondary group-hover/parent:bg-secondary dark:hover:text-off-black dark:group-hover/parent:text-off-black dark:hover:bg-off-white dark:group-hover/parent:bg-off-white transition-all shadow dark:shadow-dark hover:shadow-elevated dark:hover:shadow-dark-elevated pl-3 py-2 inline-block">
                      <div className="flex h-full items-center">
                        {/* <div className="inline-block align-top mr-2 rounded-full child:h-7 child:w-7 dark:bg-off-white">
                    <img width={60} src="/Images/calander-icon.svg" alt="trip-booking" />
                  </div> */}
                        <span className="flex small-text">{t("subscription.Book Camper Subscription")}</span>
                        <div className="inline-block align-top min-w-max child:h-6 child:w-6 dark:cssvar-secondary-to-off-white ml-2 cssvar-secondary-to-white dark:group-hover/button:cssvar-secondary-to-off-black dark:group-hover/parent:cssvar-secondary-to-off-black ml-auto">
                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g fill="none" fillRule="evenodd">
                              <path
                                d="m22.126 16-7.647-7.647a1.207 1.207 0 0 0-1.705 0l-.42.42a1.204 1.204 0 0 0 0 1.705L17.876 16l-5.522 5.522a1.203 1.203 0 0 0 0 1.704l.42.422c.47.47 1.235.469 1.705-.002L22.126 16z"
                                fill="var(--svg-color-secondary, #163435)"
                              ></path>
                            </g>
                          </svg>
                        </div>
                      </div>
                    </Link>
                  </div>

                </Slider>
              </div>
            </div>
          </div>






        </div>

        <div className="mx-5 max-w-screen-xl xl-padded:mx-auto">

          <div className="pt-8 2xl:pt-12 pb-0 mx-auto flex max-w-3xl flex-col items-center text-center">
            <p className="mb-4 whitespace-pre-line text-md">{t("subscription.Maximum Fairness")}</p>
            <h2 className="whitespace-pre-line break-words text-xl md:text-2xl">
              {t("subscription.Camper Subscription & Kilometer Prices")}
            </h2>
          </div>

          <div className="pt-8">
            <div className="md:mx-5 max-w-screen-xl xl-padded:mx-auto tabslider price-tabs">
              <Slider
                {...settingsThumbs}
                // asNavFor={nav1}
                ref={(slider) => setNav2(slider)}
                className="slider-thumbnail camper-slider subscription-slider "
              >

                <div className="off-white custom-bg overflow-hidden rounded tab-bg shadow dark:bg-off-black-desat dark:shadow-dark flex flex-col items-center justify-center p-3 text-center 2xs:rounded sm:rounded-lg sm:p-5 -mb-1 min-h-full rounded-b-none pb-2 2xs:rounded-b-none sm:rounded-b-none sm:pb-4">
                  <div className="inline-flex items-center justify-center rounded-full border p-1 dark:border-primary-dark dark:bg-off-white mb-1 xs:mb-2 lg:mb-3">
                    <div className="inline-block align-top child:h-5 child:w-5 lg:child:h-6 lg:child:w-6">
                      <img src="/Images/tab-images.svg" alt="tab-images" />
                    </div>
                  </div>
                  <p className="overflow-hidden text-ellipsis text-xs xs:text-md lg:text-md">
                    {t("subscription.Prices for Camper Subscriptions")}
                  </p>
                </div>



                <div className="custom-bg overflow-hidden rounded tab-bg shadow dark:bg-off-black-desat dark:shadow-dark flex flex-col items-center justify-center p-3 text-center 2xs:rounded sm:rounded-lg sm:p-5 -mb-1 min-h-full rounded-b-none pb-2 2xs:rounded-b-none sm:rounded-b-none sm:pb-4">
                  <div className="inline-flex items-center justify-center rounded-full border p-1 dark:border-primary-dark dark:bg-off-white mb-1 xs:mb-2 lg:mb-3">
                    <div className="inline-block align-top child:h-5 child:w-5 lg:child:h-6 lg:child:w-6">
                      <img src="/Images/tab-images-1.svg" alt="tab-images" />
                    </div>
                  </div>
                  <p className="overflow-hidden text-ellipsis text-xs xs:text-md lg:text-md">
                    {t("subscription.Prices additional kilometers")}
                  </p>
                </div>

              </Slider>

              <Slider
                className="slider-main camper-slider height-slider"
                {...settingsMain}
                ref={(slider) => setNav1(slider)}
              >
                <div>
                  <div className="h-full overflow-hidden bg-white p-6 shadow dark:bg-off-black-desat dark:shadow-dark -ml-5 min-h-[40px] rounded-lg py-0 lg:ml-0 lg:w-auto mt-0 2xl:mt-0">
                    <div className="">
                      <div className="pt-4 pb-4 text-center mx-auto max-w-4xl">
                        <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal">
                          {/* {t("subscription.The monthly price covers all expenses except fuel. This includes comprehensive vehicle insurance, maintenance, wear and tear, all applicable taxes, and registration fees, all taken care of by us.")}                          */}
                          {t("subscription.The monthly price covers all expenses except fuel.")}
                          <br />
                          {t("subscription.This includes comprehensive vehicle insurance, maintenance, wear and tear, all applicable taxes, and registration fees, all taken care of by us.")}
                        </div>
                      </div>
                      <div className="pt-4 pb-4">
                        <div className="w-[calc(100%+20px)] overflow-hidden">
                          <div className="max-w-full overflow-auto rounded-l 2xs:rounded-l-md 2xl:rounded-l-lg">
                            <table className="w-full min-w-fit border-separate border-spacing-0 rounded pr-5 2xs:rounded 2xl:rounded-lg">
                              <thead>
                                <tr>
                                  <th
                                    className="min-w-fit px-4 py-5 text-md 2xl:p-6 2xl:text-lg bg-white dark:bg-off-black-desat sticky left-0 max-w-[40vw] shadow-only-right dark:shadow-dark-only-right rounded-tl 2xs:rounded-tl-md 2xl:rounded-tl-lg border-half border-grey dark:border-grey-dark border-t border-l"
                                    style={{ width: "20%" }}
                                  >
                                    <p className="overflow-hidden text-ellipsis whitespace-pre-line">
                                      {t("subscription.Month")}
                                    </p>
                                  </th>
                                  {price.map((item) => (
                                    <th
                                      className="min-w-fit px-4 py-5 text-md 2xl:p-6 2xl:text-lg bg-white dark:bg-off-black-desat border-half border-grey dark:border-grey-dark border-t"
                                      style={{ width: "20%" }}
                                    >
                                      <p className="overflow-hidden text-ellipsis whitespace-pre-line">
                                        {item.month}
                                      </p>
                                    </th>
                                  ))}
                                </tr>
                              </thead>

                              <tbody>
                                <tr className="last:>last:bg-primary">
                                  <td
                                    className="min-w-fit bg-white p-4 text-center text-xs dark:bg-off-black-desat md:text-sm 2xl:p-6 sticky left-0 max-w-[30vw] text-md shadow-only-right dark:shadow-dark-only-right rounded-bl 2xs:rounded-bl-md 2xl:rounded-bl-lg border-half border-grey dark:border-grey-dark border-b border-l"
                                    style={{ width: "20%" }}
                                  >
                                    <p className="overflow-hidden text-ellipsis whitespace-pre-line">
                                      {t("subscription.Mth")}. {t("subscription.Fixed price")}, {t("subscription.incl. 2,000km")}
                                    </p>
                                  </td>
                                  {price.map((item, index) => (
                                    <td
                                      className="min-w-fit bg-white p-4 text-center text-xs dark:bg-off-black-desat md:text-sm 2xl:p-6 border-half border-grey dark:border-grey-dark border-b"
                                      style={{ width: "20%" }}
                                    >
                                      <p className="overflow-hidden text-ellipsis whitespace-pre-line price-font">
                                        {t("Rent.from")} {item.price}€
                                      </p>
                                    </td>
                                  ))}
                                </tr>
                              </tbody>
                            </table>

                          </div>
                        </div>
                      </div>
                      <div className="pt-4 pb-4 text-center mx-auto max-w-4xl">
                        <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal price-font mb-3">
                          {t("subscription.Monthly costs vary depending on the vehicle")}.
                          {/* <br />{t("subscription.Additionally, there's a one-time subscription fee of  €149 when you sign up")}. */}
                          {/* Additionally, there's a one-time subscription fee of €149 when you sign up. */}
                        </div>

                        <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal">
                          <span className="font-medium">
                            {t("subscription.Example Calculation")}:{" "}
                          </span>
                          {t("subscription.Euro Camper in the Camper Subscription from March to April")}.

                        </div>
                        <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal price-font price-font price-font">
                          {t("subscription.1 x €999  (March price) + 1 x €1,599 (April price) = €2,598 total subscription price")}<br />
                          {t("subscription.-> €1,299 monthly  subscription rate")}.
                        </div>
                      </div>


                    </div>
                  </div>
                </div>

                <div>
                  <div className="h-full overflow-hidden bg-white p-6 shadow dark:bg-off-black-desat dark:shadow-dark -ml-5 min-h-[40px] rounded-lg py-0 lg:ml-0 lg:w-auto mt-0 2xl:mt-0">
                    <div className="">
                      <div className="pt-4 pb-4 text-center mx-auto max-w-4xl">
                        <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal">
                          {t("subscription.Your camper subscription already includes 2,000 kilometers per month. But if you're up for even  more adventure, booking additional kilometers is a breeze")}.
                        </div>
                      </div>
                      <div className="pb-4">
                        <div className="w-[calc(100%+20px)] overflow-hidden">
                          <div className="max-w-full overflow-auto rounded-l 2xs:rounded-l-md 2xl:rounded-l-lg">
                            <table className="w-full min-w-fit border-separate border-spacing-0 rounded pr-5 2xs:rounded 2xl:rounded-lg">
                              <thead>
                                <tr>
                                  <th
                                    className="min-w-fit px-4 py-5 text-md 2xl:p-6 2xl:text-lg bg-white dark:bg-off-black-desat sticky left-0 max-w-[40vw] shadow-only-right dark:shadow-dark-only-right rounded-tl 2xs:rounded-tl-md 2xl:rounded-tl-lg border-half border-grey dark:border-grey-dark border-t border-l"
                                    style={{ width: "20%" }}
                                  >
                                    <p className="overflow-hidden text-ellipsis whitespace-pre-line">
                                      {t("subscription.Additional kilometers per month")}
                                    </p>

                                  </th>
                                  <th
                                    className="min-w-fit px-4 py-5 text-md 2xl:p-6 2xl:text-lg bg-white dark:bg-off-black-desat border-half border-grey dark:border-grey-dark border-t"
                                    style={{ width: "20%" }}
                                  >
                                    <p className="overflow-hidden text-ellipsis whitespace-pre-line">
                                      +250km
                                    </p>
                                  </th>
                                  <th
                                    className="min-w-fit px-4 py-5 text-md 2xl:p-6 2xl:text-lg bg-quaternary text-white dark:text-off-white"
                                    style={{ width: "20%" }}
                                  >
                                    <p className="overflow-hidden text-ellipsis whitespace-pre-line">
                                      +500km
                                    </p>
                                  </th>
                                  <th
                                    className="min-w-fit px-4 py-5 text-md 2xl:p-6 2xl:text-lg bg-secondary text-white dark:bg-grey dark:text-black"
                                    style={{ width: "20%" }}
                                  >
                                    <p className="overflow-hidden text-ellipsis whitespace-pre-line">
                                      +750km
                                    </p>
                                  </th>
                                  <th
                                    className="min-w-fit px-4 py-5 text-md 2xl:p-6 2xl:text-lg bg-orange dark:bg-primary-dark dark:text-off-white rounded-tr 2xs:rounded-tr-md 2xl:rounded-tr-lg"
                                    style={{ width: "20%" }}
                                  >
                                    <p className="overflow-hidden text-ellipsis whitespace-pre-line">
                                      +1,000km
                                    </p>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr className="last:>last:bg-primary">
                                  <td
                                    className="min-w-fit bg-white p-4 text-center text-xs dark:bg-off-black-desat md:text-sm 2xl:p-6 sticky left-0 max-w-[30vw] text-md shadow-only-right dark:shadow-dark-only-right rounded-bl 2xs:rounded-bl-md 2xl:rounded-bl-lg border-half border-grey dark:border-grey-dark border-b border-l"
                                    style={{ width: "20%" }}
                                  >
                                    <p className="overflow-hidden text-ellipsis whitespace-pre-line">
                                      {t("subscription.Price per Month")}
                                    </p>
                                  </td>
                                  <td
                                    className="min-w-fit bg-white p-4 text-center text-xs dark:bg-off-black-desat md:text-sm 2xl:p-6 border-half border-grey dark:border-grey-dark border-b"
                                    style={{ width: "20%" }}
                                  >
                                    <p className="overflow-hidden text-ellipsis whitespace-pre-line price-font">
                                      159€
                                    </p>
                                  </td>
                                  <td
                                    className="min-w-fit bg-white p-4 text-center text-xs dark:bg-off-black-desat md:text-sm 2xl:p-6 border-half border-grey dark:border-grey-dark border-b"
                                    style={{ width: "20%" }}
                                  >
                                    <p className="overflow-hidden text-ellipsis whitespace-pre-line price-font">
                                      279€
                                    </p>
                                  </td>
                                  <td
                                    className="min-w-fit bg-white p-4 text-center text-xs dark:bg-off-black-desat md:text-sm 2xl:p-6 border-half border-grey dark:border-grey-dark border-b"
                                    style={{ width: "20%" }}
                                  >
                                    <p className="overflow-hidden text-ellipsis whitespace-pre-line price-font">
                                      389€
                                    </p>
                                  </td>
                                  <td
                                    className="min-w-fit bg-white p-4 text-center text-xs dark:bg-off-black-desat md:text-sm 2xl:p-6 rounded-br 2xs:rounded-br-md 2xl:rounded-br-lg border-half border-grey dark:border-grey-dark border-b border-r"
                                    style={{ width: "20%" }}
                                  >
                                    <p className="overflow-hidden text-ellipsis whitespace-pre-line price-font ">
                                      529€
                                    </p>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Slider>

              <div className="pt-8 2xl:pt-12 mx-auto flex max-w-3xl flex-col items-center text-center">
                <a className="group/button block border border-transparent rounded text-md text-white dark:text-off-white button-primary-bg dark:bg-primary-dark p-3 pl-5 hover:bg-secondary group-hover/parent:bg-secondary dark:hover:text-off-black dark:group-hover/parent:text-off-black dark:hover:bg-off-white dark:group-hover/parent:bg-off-white transition-all shadow dark:shadow-dark hover:shadow-elevated dark:hover:shadow-dark-elevated col-span-2 disabled:opacity-100 sm:col-span-1" href="#book-your-campor">
                  <div className="flex h-full items-center justify-between">
                    <span className="flex">{t("subscription.Book your camper subscription")}</span>
                    <div className="inline-block align-top min-w-max child:h-6 child:w-6 dark:cssvar-secondary-to-off-white ml-2 cssvar-secondary-to-white dark:group-hover/button:cssvar-secondary-to-off-black dark:group-hover/parent:cssvar-secondary-to-off-black">
                      <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g fill="none" fillRule="evenodd"><path d="m22.126 16-7.647-7.647a1.207 1.207 0 0 0-1.705 0l-.42.42a1.204 1.204 0 0 0 0 1.705L17.876 16l-5.522 5.522a1.203 1.203 0 0 0 0 1.704l.42.422c.47.47 1.235.469 1.705-.002L22.126 16z" fill="var(--svg-color-secondary, #163435)"></path></g></svg>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div className="md:pt-8 pt-10 2xl:pt-12 md:pb-0 pb-3 mx-auto flex max-w-3xl flex-col items-center text-center">
            <h2 className="whitespace-pre-line break-words text-xl md:text-2xl">
              {t("subscription.Camper Subscription Inspiration")}:<br />
              {t("subscription.Parental Leave, Home Office, and More")}
            </h2>
          </div>

          <div className="md:pb-8 pb-2 2xl:pb-12">
            <div className="md:mx-5 max-w-screen-xl xl-padded:mx-auto">
              <Vanlife />
            </div>
          </div>


          <div className="2xl:pt-0 pt-0 pb-0 mx-auto flex max-w-4xl flex-col items-center text-center">
            <div className="inline-flex items-center justify-center rounded-full border border-primary bg-white p-3 dark:border-primary-dark dark:bg-off-white mb-5 md:mb-6">
              <div className="inline-block align-top child:h-10 child:w-10">
                <img
                  src="/Images/contact-form-img.svg"
                  alt="interested-camper"
                />
              </div>
            </div>
            <h2 className="whitespace-pre-line break-words text-xl md:text-2xl mb-4">
              {t("subscription.Frequently Asked Questions About the Camper Subscription")}
            </h2>
            <p className="whitespace-pre-line text-2md font-normal md:text-lg-paragraph md:font-normal text-20">
              {t("subscription.Here, you'll find answers to the most common questions regarding the camper subscription.")}<br />
              {t("subscription.And if your question isn't listed, just drop us a message through the contact form!")}
            </p>
          </div>

          <div className="pt-8 2xl:pt-12 pb-16 2xl:pb-16 sub-faq">
            <div className="overflow-hidden rounded bg-white shadow dark:bg-off-black-desat dark:shadow-dark 2xs:rounded-lg mx-auto p-0 max-w-3xl">
              <details className="group border-b border-b-grey last:border-b-0 dark:border-b-grey-dark">
                <summary className="justify-between flex cursor-pointer select-none items-center gap-10 py-6 px-7 2xl:py-8 2xl:px-9">

                  <h3>
                    <div className="flex items-center">
                      <p className="text-lg xs:mb-6">
                        {t("subscription.What is the Camper Subscription exactly?")}

                      </p>
                    </div>
                  </h3>
                  <div className="inline-block align-top dark:cssvar-secondary-to-off-white md:child:h-8 md:child:w-8">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="none" fillRule="evenodd">
                        <path
                          d="m16 22.126 7.647-7.647c.47-.47.47-1.234 0-1.705l-.42-.42a1.204 1.204 0 0 0-1.705 0L16 17.876l-5.522-5.522a1.203 1.203 0 0 0-1.704 0l-.422.42c-.47.47-.469 1.235.002 1.705L16 22.126z"
                          fill="var(--svg-color-secondary, #EE7214)"
                        ></path>
                      </g>
                    </svg>
                  </div>

                </summary>
                <div className="px-7 2xl:px-9">
                  <div className="">
                    <div className="pt-0 pb-8 2xl:pb-12 text-left mx-auto max-w-3xl">
                      <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal">
                        {t("subscription.The Camper Subscription combines the benefits of camper rental with those of a long-term lease. It offers maximum flexibility with a short minimum term of just two months. Included are services such as comprehensive insurance, vehicle tax, and assumption of maintenance costs. In short, the Camper Subscription allows you to enjoy a camper without the usual hassle associated with vehicle ownership while avoiding a long-term commitment of 24 to 36 months to a contract")}.
                      </div>
                      <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal"></div>

                    </div>
                  </div>
                </div>
              </details>
              <details className="group border-b border-b-grey last:border-b-0 dark:border-b-grey-dark">
                <summary className="justify-between flex cursor-pointer select-none items-center gap-10 py-6 px-7 2xl:py-8 2xl:px-9">

                  <h3>
                    <div className="flex items-center">
                      <p className="text-lg xs:mb-6">
                        {t("subscription.How does the payment work?")}
                      </p>
                    </div>
                  </h3>
                  <div className="inline-block align-top dark:cssvar-secondary-to-off-white md:child:h-8 md:child:w-8">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="none" fillRule="evenodd">
                        <path
                          d="m16 22.126 7.647-7.647c.47-.47.47-1.234 0-1.705l-.42-.42a1.204 1.204 0 0 0-1.705 0L16 17.876l-5.522-5.522a1.203 1.203 0 0 0-1.704 0l-.422.42c-.47.47-.469 1.235.002 1.705L16 22.126z"
                          fill="var(--svg-color-secondary, #EE7214)"
                        ></path>
                      </g>
                    </svg>
                  </div>

                </summary>
                <div className="px-7 2xl:px-9">
                  <div className="">
                    <div className="pt-0 pb-8 2xl:pb-12 text-left mx-auto max-w-3xl">
                      <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal price-font">
                        {t("subscription.You pay the contributions every month. In other words, the first installment is due as soon as the contract is finalized. Then it starts in the second month of the term and so on – every month at the beginning")}.
                      </div>
                    </div>
                  </div>
                </div>
              </details>
              <details className="group border-b border-b-grey last:border-b-0 dark:border-b-grey-dark">
                <summary className="justify-between flex cursor-pointer select-none items-center gap-10 py-6 px-7 2xl:py-8 2xl:px-9">

                  <h3>
                    <div className="flex items-center">
                      <p className="text-lg xs:mb-6">
                        {t("subscription.Who is allowed to drive the vehicle?")}
                      </p>
                    </div>
                  </h3>
                  <div className="inline-block align-top dark:cssvar-secondary-to-off-white md:child:h-8 md:child:w-8">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="none" fillRule="evenodd">
                        <path
                          d="m16 22.126 7.647-7.647c.47-.47.47-1.234 0-1.705l-.42-.42a1.204 1.204 0 0 0-1.705 0L16 17.876l-5.522-5.522a1.203 1.203 0 0 0-1.704 0l-.422.42c-.47.47-.469 1.235.002 1.705L16 22.126z"
                          fill="var(--svg-color-secondary, #EE7214)"
                        ></path>
                      </g>
                    </svg>
                  </div>

                </summary>
                <div className="px-7 2xl:px-9">
                  <div className="">
                    <div className="pt-0 pb-8 2xl:pb-12 text-left mx-auto max-w-3xl">
                      <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal">
                        {t("subscription.We list the main person renting the camper and anyone else who wants to drive it in the rental agreement. At the key handover, you must show your original driver's licenses – unfortunately, copies do not count")}
                      </div>
                    </div>
                  </div>
                </div>
              </details>
              <details className="group border-b border-b-grey last:border-b-0 dark:border-b-grey-dark">
                <summary className="justify-between flex cursor-pointer select-none items-center gap-10 py-6 px-7 2xl:py-8 2xl:px-9">

                  <h3>
                    <div className="flex items-center">
                      <p className="text-lg xs:mb-6">
                        {t("subscription.Who pays for fuel, oil, and AdBlue?")}
                      </p>
                    </div>
                  </h3>
                  <div className="inline-block align-top dark:cssvar-secondary-to-off-white md:child:h-8 md:child:w-8">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="none" fillRule="evenodd">
                        <path
                          d="m16 22.126 7.647-7.647c.47-.47.47-1.234 0-1.705l-.42-.42a1.204 1.204 0 0 0-1.705 0L16 17.876l-5.522-5.522a1.203 1.203 0 0 0-1.704 0l-.422.42c-.47.47-.469 1.235.002 1.705L16 22.126z"
                          fill="var(--svg-color-secondary, #EE7214)"
                        ></path>
                      </g>
                    </svg>
                  </div>

                </summary>
                <div className="px-7 2xl:px-9">
                  <div className="">
                    <div className="pt-0 pb-8 2xl:pb-12 text-left mx-auto max-w-3xl">
                      <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal">
                        {t("subscription.We deliver the car fully fueled – diesel and AdBlue included – and would like to receive it back the same way. If oil or other fluids run low on the road, please top them up at your own expense. This also applies if you need to refill gas")}.
                      </div>
                      <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal"></div>

                    </div>
                  </div>
                </div>
              </details>
              <details className="group border-b border-b-grey last:border-b-0 dark:border-b-grey-dark">
                <summary className="justify-between flex cursor-pointer select-none items-center gap-10 py-6 px-7 2xl:py-8 2xl:px-9">

                  <h3>
                    <div className="flex items-center">
                      <p className="text-lg xs:mb-6">
                        {t("subscription.What is the minimum term?")}
                      </p>
                    </div>
                  </h3>
                  <div className="inline-block align-top dark:cssvar-secondary-to-off-white md:child:h-8 md:child:w-8">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="none" fillRule="evenodd">
                        <path
                          d="m16 22.126 7.647-7.647c.47-.47.47-1.234 0-1.705l-.42-.42a1.204 1.204 0 0 0-1.705 0L16 17.876l-5.522-5.522a1.203 1.203 0 0 0-1.704 0l-.422.42c-.47.47-.469 1.235.002 1.705L16 22.126z"
                          fill="var(--svg-color-secondary, #EE7214)"
                        ></path>
                      </g>
                    </svg>
                  </div>

                </summary>
                <div className="px-7 2xl:px-9">
                  <div className="">
                    <div className="pt-0 pb-8 2xl:pb-12 text-left mx-auto max-w-3xl">
                      <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal">
                        {t("subscription.The minimum term is 2 months.")}
                      </div>
                    </div>
                  </div>
                </div>
              </details>

              <details className="group border-b border-b-grey last:border-b-0 dark:border-b-grey-dark">
                <summary className="justify-between flex cursor-pointer select-none items-center gap-10 py-6 px-7 2xl:py-8 2xl:px-9">

                  <h3>
                    <div className="flex items-center">
                      <p className="text-lg xs:mb-6">
                        {t("subscription.What is the maximum term?")}
                      </p>
                    </div>
                  </h3>
                  <div className="inline-block align-top dark:cssvar-secondary-to-off-white md:child:h-8 md:child:w-8">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="none" fillRule="evenodd">
                        <path
                          d="m16 22.126 7.647-7.647c.47-.47.47-1.234 0-1.705l-.42-.42a1.204 1.204 0 0 0-1.705 0L16 17.876l-5.522-5.522a1.203 1.203 0 0 0-1.704 0l-.422.42c-.47.47-.469 1.235.002 1.705L16 22.126z"
                          fill="var(--svg-color-secondary, #EE7214)"
                        ></path>
                      </g>
                    </svg>
                  </div>

                </summary>
                <div className="px-7 2xl:px-9">
                  <div className="">
                    <div className="pt-0 pb-8 2xl:pb-12 text-left mx-auto max-w-3xl">
                      <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal">
                        {t("subscription.The maximum term is 12 months. And if you want more, we simply start with a new contract after 12 months")}.
                      </div>
                    </div>
                  </div>
                </div>
              </details>

              <details className="group border-b border-b-grey last:border-b-0 dark:border-b-grey-dark">
                <summary className="justify-between flex cursor-pointer select-none items-center gap-10 py-6 px-7 2xl:py-8 2xl:px-9">

                  <h3>
                    <div className="flex items-center">
                      <p className="text-lg xs:mb-6">
                        {t("subscription.Who can use the Camper Subscription?")}
                      </p>
                    </div>
                  </h3>
                  <div className="inline-block align-top dark:cssvar-secondary-to-off-white md:child:h-8 md:child:w-8">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="none" fillRule="evenodd">
                        <path
                          d="m16 22.126 7.647-7.647c.47-.47.47-1.234 0-1.705l-.42-.42a1.204 1.204 0 0 0-1.705 0L16 17.876l-5.522-5.522a1.203 1.203 0 0 0-1.704 0l-.422.42c-.47.47-.469 1.235.002 1.705L16 22.126z"
                          fill="var(--svg-color-secondary, #EE7214)"
                        ></path>
                      </g>
                    </svg>
                  </div>
                </summary>
                <div className="px-7 2xl:px-9">
                  <div className="">
                    <div className="pt-0 pb-8 2xl:pb-12 text-left mx-auto max-w-3xl">
                      <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal">
                        {t("subscription.You can sign up for the Camper Subscription if you are at least 21 years old, have held a class B driver's license for at least one year, and have your residence in Germany")}.
                      </div>
                    </div>
                  </div>
                </div>
              </details>


              <details className="group border-b border-b-grey last:border-b-0 dark:border-b-grey-dark">
                <summary className="justify-between flex cursor-pointer select-none items-center gap-10 py-6 px-7 2xl:py-8 2xl:px-9">

                  <h3>
                    <div className="flex items-center">
                      <p className="text-lg xs:mb-6">
                        {t("subscription.Does the takeover have to be at the beginning of the month?")}
                      </p>
                    </div>
                  </h3>
                  <div className="inline-block align-top dark:cssvar-secondary-to-off-white md:child:h-8 md:child:w-8">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="none" fillRule="evenodd">
                        <path
                          d="m16 22.126 7.647-7.647c.47-.47.47-1.234 0-1.705l-.42-.42a1.204 1.204 0 0 0-1.705 0L16 17.876l-5.522-5.522a1.203 1.203 0 0 0-1.704 0l-.422.42c-.47.47-.469 1.235.002 1.705L16 22.126z"
                          fill="var(--svg-color-secondary, #EE7214)"
                        ></path>
                      </g>
                    </svg>
                  </div>
                </summary>
                <div className="px-7 2xl:px-9">
                  <div className="">
                    <div className="pt-0 pb-8 2xl:pb-12 text-left mx-auto max-w-3xl">
                      <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal">
                        {t("subscription.No, you decide when you want to start. We calculate the costs proportionally from the day your subscription begins, for example, from March 20th")}.
                      </div>
                    </div>
                  </div>
                </div>
              </details>


              <details className="group border-b border-b-grey last:border-b-0 dark:border-b-grey-dark">
                <summary className="justify-between flex cursor-pointer select-none items-center gap-10 py-6 px-7 2xl:py-8 2xl:px-9">

                  <h3>
                    <div className="flex items-center">
                      <p className="text-lg xs:mb-6">
                        {t("subscription.Can I cancel my contract before the start of the subscription?")}
                      </p>
                    </div>
                  </h3>
                  <div className="inline-block align-top dark:cssvar-secondary-to-off-white md:child:h-8 md:child:w-8">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="none" fillRule="evenodd">
                        <path
                          d="m16 22.126 7.647-7.647c.47-.47.47-1.234 0-1.705l-.42-.42a1.204 1.204 0 0 0-1.705 0L16 17.876l-5.522-5.522a1.203 1.203 0 0 0-1.704 0l-.422.42c-.47.47-.469 1.235.002 1.705L16 22.126z"
                          fill="var(--svg-color-secondary, #EE7214)"
                        ></path>
                      </g>
                    </svg>
                  </div>
                </summary>
                <div className="px-7 2xl:px-9">
                  <div className="">
                    <div className="pt-0 pb-8 2xl:pb-12 text-left mx-auto max-w-3xl">
                      <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal">
                        {/* Yes, you can. If you cancel at least 60 days before the planned start, it will cost you only the start fee of €169. After that, an additional charge equivalent to the first month's rate will be incurred as a cancellation fee, which is non-refundable. */}
                        {t("subscription.Yes, you can. If you cancel at least 60 days before the planned start, the cancellation is free. After that, the first month's rate will be incurred as a cancellation fee, which is non-refundable")}.
                      </div>
                    </div>
                  </div>
                </div>
              </details>


              <details className="group border-b border-b-grey last:border-b-0 dark:border-b-grey-dark">
                <summary className="justify-between flex cursor-pointer select-none items-center gap-10 py-6 px-7 2xl:py-8 2xl:px-9">

                  <h3>
                    <div className="flex items-center">
                      <p className="text-lg xs:mb-6">
                        {t("subscription.Can I cancel the subscription early?")}
                      </p>
                    </div>
                  </h3>
                  <div className="inline-block align-top dark:cssvar-secondary-to-off-white md:child:h-8 md:child:w-8">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="none" fillRule="evenodd">
                        <path
                          d="m16 22.126 7.647-7.647c.47-.47.47-1.234 0-1.705l-.42-.42a1.204 1.204 0 0 0-1.705 0L16 17.876l-5.522-5.522a1.203 1.203 0 0 0-1.704 0l-.422.42c-.47.47-.469 1.235.002 1.705L16 22.126z"
                          fill="var(--svg-color-secondary, #EE7214)"
                        ></path>
                      </g>
                    </svg>
                  </div>
                </summary>
                <div className="px-7 2xl:px-9">
                  <div className="">
                    <div className="pt-0 pb-8 2xl:pb-12 text-left mx-auto max-w-3xl">
                      <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal">
                        {t("subscription.Unfortunately, that is not possible. If you are unsure, we recommend extending the subscription if the camper is still available")}.
                      </div>
                    </div>
                  </div>
                </div>
              </details>


              <details className="group border-b border-b-grey last:border-b-0 dark:border-b-grey-dark">
                <summary className="justify-between flex cursor-pointer select-none items-center gap-10 py-6 px-7 2xl:py-8 2xl:px-9">

                  <h3>
                    <div className="flex items-center">
                      <p className="text-lg xs:mb-6">
                        {t("subscription.Is there a deposit?")}
                      </p>
                    </div>
                  </h3>
                  <div className="inline-block align-top dark:cssvar-secondary-to-off-white md:child:h-8 md:child:w-8">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="none" fillRule="evenodd">
                        <path
                          d="m16 22.126 7.647-7.647c.47-.47.47-1.234 0-1.705l-.42-.42a1.204 1.204 0 0 0-1.705 0L16 17.876l-5.522-5.522a1.203 1.203 0 0 0-1.704 0l-.422.42c-.47.47-.469 1.235.002 1.705L16 22.126z"
                          fill="var(--svg-color-secondary, #EE7214)"
                        ></path>
                      </g>
                    </svg>
                  </div>
                </summary>
                <div className="px-7 2xl:px-9">
                  <div className="">
                    <div className="pt-0 pb-8 2xl:pb-12 text-left mx-auto max-w-3xl">
                      <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal">
                        {t("subscription.Yes, we require a deposit of €1500, which you can pay by EC card or in cash upon pickup. You will receive this back when you return the camper in good condition")}.
                      </div>
                    </div>
                  </div>
                </div>
              </details>


              <details className="group border-b border-b-grey last:border-b-0 dark:border-b-grey-dark">
                <summary className="justify-between flex cursor-pointer select-none items-center gap-10 py-6 px-7 2xl:py-8 2xl:px-9">

                  <h3>
                    <div className="flex items-center">
                      <p className="text-lg xs:mb-6">
                        {t("subscription.How is the camper insured?")}
                      </p>
                    </div>
                  </h3>
                  <div className="inline-block align-top dark:cssvar-secondary-to-off-white md:child:h-8 md:child:w-8">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="none" fillRule="evenodd">
                        <path
                          d="m16 22.126 7.647-7.647c.47-.47.47-1.234 0-1.705l-.42-.42a1.204 1.204 0 0 0-1.705 0L16 17.876l-5.522-5.522a1.203 1.203 0 0 0-1.704 0l-.422.42c-.47.47-.469 1.235.002 1.705L16 22.126z"
                          fill="var(--svg-color-secondary, #EE7214)"
                        ></path>
                      </g>
                    </svg>
                  </div>
                </summary>
                <div className="px-7 2xl:px-9">
                  <div className="">
                    <div className="pt-0 pb-8 2xl:pb-12 text-left mx-auto max-w-3xl">
                      <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal">
                        {t("subscription.The subscription includes comprehensive insurance with a deductible of €1,500 per claim and liability insurance with coverage of €100 million")}.
                      </div>
                    </div>
                  </div>
                </div>
              </details>

              <details className="group border-b border-b-grey last:border-b-0 dark:border-b-grey-dark">
                <summary className="justify-between flex cursor-pointer select-none items-center gap-10 py-6 px-7 2xl:py-8 2xl:px-9">

                  <h3>
                    <div className="flex items-center">
                      <p className="text-lg xs:mb-6">
                        {t("subscription.And the extra kilometers?")}
                      </p>
                    </div>
                  </h3>
                  <div className="inline-block align-top dark:cssvar-secondary-to-off-white md:child:h-8 md:child:w-8">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="none" fillRule="evenodd">
                        <path
                          d="m16 22.126 7.647-7.647c.47-.47.47-1.234 0-1.705l-.42-.42a1.204 1.204 0 0 0-1.705 0L16 17.876l-5.522-5.522a1.203 1.203 0 0 0-1.704 0l-.422.42c-.47.47-.469 1.235.002 1.705L16 22.126z"
                          fill="var(--svg-color-secondary, #EE7214)"
                        ></path>
                      </g>
                    </svg>
                  </div>
                </summary>
                <div className="px-7 2xl:px-9">
                  <div className="">
                    <div className="pt-0 pb-8 2xl:pb-12 text-left mx-auto max-w-3xl">
                      <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal">
                        {t("subscription.The monthly rate includes 2000 free kilometers. If you drive beyond that, additional kilometers are charged at €0.35 (including VAT) per kilometer. The settlement takes place after you return your camper. You also have the option to book additional kilometer packages at the time of contract signing, which are also based on your booked total term. You determine the distribution of kilometers over the term yourself, and unused kilometers can be easily used in the following month. Please note that up to 1000 kilometers per month can be additionally booked in advance, and the maximum of 3000 km per month must not be exceeded. If you drive more than the maximum, the additional kilometers will be charged at €0.70 per kilometer")}.
                      </div>
                    </div>
                  </div>
                </div>
              </details>

              {/* <details className="group border-b border-b-grey last:border-b-0 dark:border-b-grey-dark">
                <summary className="justify-between flex cursor-pointer select-none items-center gap-10 py-6 px-7 2xl:py-8 2xl:px-9">

                  <h3>
                    <div className="flex items-center">
                      <p className="text-lg xs:mb-6">
                        What does the one-time start fee include?
                      </p>
                    </div>
                  </h3>
                  <div className="inline-block align-top dark:cssvar-secondary-to-off-white md:child:h-8 md:child:w-8">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="none" fillRule="evenodd">
                        <path
                          d="m16 22.126 7.647-7.647c.47-.47.47-1.234 0-1.705l-.42-.42a1.204 1.204 0 0 0-1.705 0L16 17.876l-5.522-5.522a1.203 1.203 0 0 0-1.704 0l-.422.42c-.47.47-.469 1.235.002 1.705L16 22.126z"
                          fill="var(--svg-color-secondary, #EE7214)"
                        ></path>
                      </g>
                    </svg>
                  </div>
                </summary>
                <div className="px-7 2xl:px-9">
                  <div className="">
                    <div className="pt-0 pb-8 2xl:pb-12 text-left mx-auto max-w-3xl">
                      <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal">
                        At contract signing, there is a one-time fee of €169. This covers the costs for creating your profile and credit check.
                      </div>
                    </div>
                  </div>
                </div>
              </details> */}
              <details className="group border-b border-b-grey last:border-b-0 dark:border-b-grey-dark">
                <summary className="justify-between flex cursor-pointer select-none items-center gap-10 py-6 px-7 2xl:py-8 2xl:px-9">

                  <h3>
                    <div className="flex items-center">
                      <p className="text-lg xs:mb-6">
                        {t("subscription.What does the one-time entry fee include?")}
                      </p>
                    </div>
                  </h3>
                  <div className="inline-block align-top dark:cssvar-secondary-to-off-white md:child:h-8 md:child:w-8">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="none" fillRule="evenodd">
                        <path
                          d="m16 22.126 7.647-7.647c.47-.47.47-1.234 0-1.705l-.42-.42a1.204 1.204 0 0 0-1.705 0L16 17.876l-5.522-5.522a1.203 1.203 0 0 0-1.704 0l-.422.42c-.47.47-.469 1.235.002 1.705L16 22.126z"
                          fill="var(--svg-color-secondary, #EE7214)"
                        ></path>
                      </g>
                    </svg>
                  </div>
                </summary>
                <div className="px-7 2xl:px-9">
                  <div className="">
                    <div className="pt-0 pb-8 2xl:pb-12 text-left mx-auto max-w-3xl">
                      <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal">
                        {t("subscription.A one-off fee of €169 is charged when the contract is concluded. This covers the costs for the creation of your profile and the credit check")}.
                      </div>
                    </div>
                  </div>
                </div>
              </details>

              <details className="group border-b border-b-grey last:border-b-0 dark:border-b-grey-dark">
                <summary className="justify-between flex cursor-pointer select-none items-center gap-10 py-6 px-7 2xl:py-8 2xl:px-9">

                  <h3>
                    <div className="flex items-center">
                      <p className="text-lg xs:mb-6">
                        {t("subscription.Can the deductible be reduced?")}
                      </p>
                    </div>
                  </h3>
                  <div className="inline-block align-top dark:cssvar-secondary-to-off-white md:child:h-8 md:child:w-8">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="none" fillRule="evenodd">
                        <path
                          d="m16 22.126 7.647-7.647c.47-.47.47-1.234 0-1.705l-.42-.42a1.204 1.204 0 0 0-1.705 0L16 17.876l-5.522-5.522a1.203 1.203 0 0 0-1.704 0l-.422.42c-.47.47-.469 1.235.002 1.705L16 22.126z"
                          fill="var(--svg-color-secondary, #EE7214)"
                        ></path>
                      </g>
                    </svg>
                  </div>
                </summary>
                <div className="px-7 2xl:px-9">
                  <div className="">
                    <div className="pt-0 pb-8 2xl:pb-12 text-left mx-auto max-w-3xl">
                      <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal">
                        {t("subscription.Unfortunately, we do not offer a reduction of the deductible, but you can additionally insure yourself privately")}.
                      </div>
                    </div>
                  </div>
                </div>
              </details>


              <details className="group border-b border-b-grey last:border-b-0 dark:border-b-grey-dark">
                <summary className="justify-between flex cursor-pointer select-none items-center gap-10 py-6 px-7 2xl:py-8 2xl:px-9">

                  <h3>
                    <div className="flex items-center">
                      <p className="text-lg xs:mb-6">
                        {t("subscription.Is a camper inspection possible in advance?")}
                      </p>
                    </div>
                  </h3>
                  <div className="inline-block align-top dark:cssvar-secondary-to-off-white md:child:h-8 md:child:w-8">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="none" fillRule="evenodd">
                        <path
                          d="m16 22.126 7.647-7.647c.47-.47.47-1.234 0-1.705l-.42-.42a1.204 1.204 0 0 0-1.705 0L16 17.876l-5.522-5.522a1.203 1.203 0 0 0-1.704 0l-.422.42c-.47.47-.469 1.235.002 1.705L16 22.126z"
                          fill="var(--svg-color-secondary, #EE7214)"
                        ></path>
                      </g>
                    </svg>
                  </div>
                </summary>
                <div className="px-7 2xl:px-9">
                  <div className="">
                    <div className="pt-0 pb-8 2xl:pb-12 text-left mx-auto max-w-3xl">
                      <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal">
                        {t("subscription.Of course, just make an appointment with us to view the camper")}.
                      </div>
                    </div>
                  </div>
                </div>
              </details>


              <details className="group border-b border-b-grey last:border-b-0 dark:border-b-grey-dark">
                <summary className="justify-between flex cursor-pointer select-none items-center gap-10 py-6 px-7 2xl:py-8 2xl:px-9">

                  <h3>
                    <div className="flex items-center">
                      <p className="text-lg xs:mb-6">
                        {t("subscription.Which countries am I allowed to travel to with the camper?")}
                      </p>
                    </div>
                  </h3>
                  <div className="inline-block align-top dark:cssvar-secondary-to-off-white md:child:h-8 md:child:w-8">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="none" fillRule="evenodd">
                        <path
                          d="m16 22.126 7.647-7.647c.47-.47.47-1.234 0-1.705l-.42-.42a1.204 1.204 0 0 0-1.705 0L16 17.876l-5.522-5.522a1.203 1.203 0 0 0-1.704 0l-.422.42c-.47.47-.469 1.235.002 1.705L16 22.126z"
                          fill="var(--svg-color-secondary, #EE7214)"
                        ></path>
                      </g>
                    </svg>
                  </div>
                </summary>
                <div className="px-7 2xl:px-9">
                  <div className="">
                    <div className="pt-0 pb-8 2xl:pb-12 text-left mx-auto max-w-3xl">
                      <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal">
                        {t("subscription.You may use the rental vehicle exclusively in the following countries Albania, Andorra, Belgium, Bosnia and Herzegovina, Bulgaria, Germany, Denmark, Estonia, France, Finland, Greece, Great Britain, Italy, Ireland, Iceland, Croatia, Luxembourg, Liechtenstein, Lithuania, Latvia, Malta, Moldova, Monaco, Montenegro, Netherlands, North Macedonia, Norway, Austria, Portugal, Poland, Romania, San Marino, Sweden, Slovakia, Spain, Switzerland, Serbia, Slovenia, Czech Republic, Hungary, Vatican City, and Cyprus. Please note that you are not allowed to use the vehicle temporarily and continuously in a country other than Germany for more than three months in a row")}.
                      </div>
                    </div>
                  </div>
                </div>
              </details>


              <details className="group border-b border-b-grey last:border-b-0 dark:border-b-grey-dark">
                <summary className="justify-between flex cursor-pointer select-none items-center gap-10 py-6 px-7 2xl:py-8 2xl:px-9">

                  <h3>
                    <div className="flex items-center">
                      <p className="text-lg xs:mb-6">
                        {t("subscription.What if a service is due?")}
                      </p>
                    </div>
                  </h3>
                  <div className="inline-block align-top dark:cssvar-secondary-to-off-white md:child:h-8 md:child:w-8">
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="none" fillRule="evenodd">
                        <path
                          d="m16 22.126 7.647-7.647c.47-.47.47-1.234 0-1.705l-.42-.42a1.204 1.204 0 0 0-1.705 0L16 17.876l-5.522-5.522a1.203 1.203 0 0 0-1.704 0l-.422.42c-.47.47-.469 1.235.002 1.705L16 22.126z"
                          fill="var(--svg-color-secondary, #EE7214)"
                        ></path>
                      </g>
                    </svg>
                  </div>
                </summary>
                <div className="px-7 2xl:px-9">
                  <div className="">
                    <div className="pt-0 pb-8 2xl:pb-12 text-left mx-auto max-w-3xl">
                      <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal">
                        {t("subscription.No problem. Bring the camper by, and we'll take care of the service within half a day")}.
                      </div>
                    </div>
                  </div>
                </div>
              </details>
            </div>


          </div>



          <div className="pb-0 mx-auto flex max-w-3xl flex-col items-center text-center">
            <h2 className="whitespace-pre-line break-words text-xl md:text-2xl">
              {t("subscription.Is the Born To Camp Camper Subscription really more expensive than buying or leasing a car?")}
            </h2>


            <div className="pt-12 pb-12 w-c-100 leasing-table">
              <table className="w-c-100">
                <tr>
                  <th align="left" className="p-4 pl-8">{t("subscription.Services")}</th>
                  <th width={160} align="center" className="p-4 pl-4">{t("subscription.Leasing")}</th>
                  <th width={160} align="center" className="color-white p-4 pl-4">{t("Contact.Camper Subscription")}</th>
                </tr>

                <tr>
                  <td align="left" className="p-4 pl-8">
                    {t("subscription.No residual value risk")}
                  </td>
                  <td align="center" className="p-4 pl-8">
                    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" >
                      <path d="M4 12.6111L8.92308 17.5L20 6.5" stroke="#093409" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </td>
                  <td align="center" className="p-4 pl-8">
                    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" >
                      <path d="M4 12.6111L8.92308 17.5L20 6.5" stroke="#fff" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </td>
                </tr>

                <tr>
                  <td align="left" className="p-4 pl-8">
                    {t("subscription.No depreciation due to usage")}
                  </td>
                  <td align="center" className="p-4 pl-8">
                    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" >
                      <path d="M4 12.6111L8.92308 17.5L20 6.5" stroke="#093409" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </td>
                  <td align="center" className="p-4 pl-8">
                    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" >
                      <path d="M4 12.6111L8.92308 17.5L20 6.5" stroke="#fff" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </td>
                </tr>

                <tr>
                  <td align="left" className="p-4 pl-8">
                    {t("subscription.Short and flexible term")}
                  </td>
                  <td align="center" className="p-4 pl-8">
                    <svg width="15px" height="15px" viewBox="-0.5 0 25 25" fill="none">
                      <path d="M3 21.32L21 3.32001" stroke="#000000" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M3 3.32001L21 21.32" stroke="#000000" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </td>
                  <td align="center" className="p-4 pl-8">
                    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" >
                      <path d="M4 12.6111L8.92308 17.5L20 6.5" stroke="#fff" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </td>
                </tr>

                <tr>
                  <td align="left" className="p-4 pl-8">
                    {t("home.Insurance")}
                  </td>
                  <td align="center" className="p-4 pl-8">
                    <svg width="15px" height="15px" viewBox="-0.5 0 25 25" fill="none">
                      <path d="M3 21.32L21 3.32001" stroke="#000000" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M3 3.32001L21 21.32" stroke="#000000" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </td>
                  <td align="center" className="p-4 pl-8">
                    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" >
                      <path d="M4 12.6111L8.92308 17.5L20 6.5" stroke="#fff" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </td>
                </tr>

                <tr>
                  <td align="left" className="p-4 pl-8">
                    {t("subscription.Service and maintenance")}
                  </td>
                  <td align="center" className="p-4 pl-8">
                    <svg width="15px" height="15px" viewBox="-0.5 0 25 25" fill="none">
                      <path d="M3 21.32L21 3.32001" stroke="#000000" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M3 3.32001L21 21.32" stroke="#000000" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </td>
                  <td align="center" className="p-4 pl-8">
                    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" >
                      <path d="M4 12.6111L8.92308 17.5L20 6.5" stroke="#fff" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </td>
                </tr>

                <tr>
                  <td align="left" className="p-4 pl-8">
                    {t("subscription.Vehicle tax")}
                  </td>
                  <td align="center" className="p-4 pl-8">
                    <svg width="15px" height="15px" viewBox="-0.5 0 25 25" fill="none">
                      <path d="M3 21.32L21 3.32001" stroke="#000000" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M3 3.32001L21 21.32" stroke="#000000" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </td>
                  <td align="center" className="p-4 pl-8">
                    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" >
                      <path d="M4 12.6111L8.92308 17.5L20 6.5" stroke="#fff" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </td>
                </tr>

                <tr>
                  <td align="left" className="p-4 pl-8">
                    {t("subscription.Tires (change, storage, winter tires)")}
                  </td>
                  <td align="center" className="p-4 pl-8">
                    <svg width="15px" height="15px" viewBox="-0.5 0 25 25" fill="none">
                      <path d="M3 21.32L21 3.32001" stroke="#000000" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M3 3.32001L21 21.32" stroke="#000000" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </td>
                  <td align="center" className="p-4 pl-8">
                    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" >
                      <path d="M4 12.6111L8.92308 17.5L20 6.5" stroke="#fff" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </td>
                </tr>

                <tr>
                  <td align="left" className="p-4 pl-8">
                    {t("subscription.Registration and transfer costs")}
                  </td>
                  <td align="center" className="p-4 pl-8">
                    <svg width="15px" height="15px" viewBox="-0.5 0 25 25" fill="none">
                      <path d="M3 21.32L21 3.32001" stroke="#000000" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M3 3.32001L21 21.32" stroke="#000000" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </td>
                  <td align="center" className="p-4 pl-8">
                    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" >
                      <path d="M4 12.6111L8.92308 17.5L20 6.5" stroke="#fff" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </td>
                </tr>

                <tr>
                  <td align="left" className="p-4 pl-8">
                    {t("subscription.Wear and tear repairs")}
                  </td>
                  <td align="center" className="p-4 pl-8">
                    <svg width="15px" height="15px" viewBox="-0.5 0 25 25" fill="none">
                      <path d="M3 21.32L21 3.32001" stroke="#000000" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M3 3.32001L21 21.32" stroke="#000000" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </td>
                  <td align="center" className="p-4 pl-8">
                    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" >
                      <path d="M4 12.6111L8.92308 17.5L20 6.5" stroke="#fff" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </td>
                </tr>

                <tr>
                  <td align="left" className="p-4 pl-8">
                    {t("subscription.Fuel")}
                  </td>
                  <td align="center" className="p-4 pl-8">
                    <svg width="15px" height="15px" viewBox="-0.5 0 25 25" fill="none">
                      <path d="M3 21.32L21 3.32001" stroke="#000000" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M3 3.32001L21 21.32" stroke="#000000" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </td>
                  <td align="center" className="p-4 pl-8">
                    <svg width="15px" height="15px" viewBox="-0.5 0 25 25" fill="none">
                      <path d="M3 21.32L21 3.32001" stroke="#fff" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M3 3.32001L21 21.32" stroke="#fff" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </td>
                </tr>




              </table>
            </div>

          </div>

          <div className="">
            <div className=" overflow-hidden rounded bg-white shadow dark:bg-off-black-desat dark:shadow-dark 2xs:rounded-lg group/parent mask-image relative p-0 md:flex md:min-h-[400px] md:rounded-xl md:bg-transparent dark:md:bg-transparent justify-end">
              <Link to={"/contactus"} className="w-full md:flex justify-end">
                <div className="md:hidden">
                  <div className="overflow-hidden">
                    <div className="-ml-[5%] w-[110%] overflow-hidden rounded-b-[60%20%] px-[5%]">
                      <div className="relative">
                        <picture className="text-0">
                          <img
                            className="inline-block max-w-full object-cover dark:brightness-90 max-h-[40vh] w-full group-hover/parent:scale-110 transition-all duration-300"
                            src="/Images/Helpccenter.png"
                            alt="Camper picture"
                          />
                        </picture>
                      </div>
                    </div>
                  </div>
                </div>
                <picture className=" text-0 absolute top-0 left-0 z-background hidden h-full w-full transition-all duration-300 group-hover/parent:scale-105 md:block md:group-hover/parent:scale-[103%]">
                  <img
                    className="inline-block max-w-full object-cover dark:brightness-90 h-full w-full"
                    src="/Images/Helpccenter-ext.jpg"
                    alt="Camper picture"
                  />
                </picture>
                <div className="relative -mt-10 md:mb-4 mb-2 flex justify-center xs:mb-4 md:hidden">
                  <div className="inline-block align-top dark:cssvar-white-to-off-white dark:cssvar-secondary-to-secondary dark:cssvar-primary-to-primary-dark child:h-20 child:w-20">
                    <img src="/Images/helpcenter.svg" alt="selection-icon" />
                  </div>
                </div>
                <div className="z-0 m-6 mt-0 flex flex-col text-center xs:mt-0 md:m-5 md:mt-5 md:min-h-[calc(100%-theme(spacing.5)*2)] md:w-full md:max-w-1/2 md:rounded-lg md:bg-white md:p-8 md:text-left md:shadow md:dark:bg-off-black-desat xl:max-w-[45%] 2xl:m-9 2xl:mt-9 2xl:min-h-[calc(100%-theme(spacing.9)*2)]">
                  <div className="md:mb-3 mb-2 flex items-center justify-center md:justify-start">
                    <div className="relative mr-4 hidden md:block">
                      <div className="inline-block align-top dark:cssvar-white-to-off-white dark:cssvar-secondary-to-secondary dark:cssvar-primary-to-primary-dark child:h-16 child:w-16">
                        <img src="/Images/helpcenter.svg" alt="selection-icon" />
                      </div>
                    </div>
                    <p className="text-lg">{t("subscription.Find you answers")}</p>
                  </div>
                  <h2 className="whitespace-pre-line break-words md:mb-4 mb-2 text-xl xs:mb-6">
                    {t("subscription.Our Helpcenter")}
                  </h2>
                  <div className="mb-4 md:mb-6">
                    <div className="min-h-[30px] break-words text-sm 2xl:text-2md 2xl:font-normal helpcenter-text md:mb-0 mb-3 image-box-text">
                      {t("subscription.Can I take my dog with me? Do I have a kilometre limit? Do I have to pay attention to anything when choosing a camper? In the FAQ you will find the most frequently asked questions about camper rental, subscription, sale and trip planner")}.
                    </div>
                  </div>
                  <div className="group/button block disabled:opacity-50 border border-transparent rounded text-md text-white dark:text-off-white bg-primary dark:bg-primary-dark p-3 pl-5 hover:bg-secondary group-hover/parent:bg-secondary dark:hover:text-off-black dark:group-hover/parent:text-off-black dark:hover:bg-off-white dark:group-hover/parent:bg-off-white transition-all shadow dark:shadow-dark hover:shadow-elevated dark:hover:shadow-dark-elevated w-full md:mt-auto">
                    <div className="flex h-full items-center justify-between">
                      <span className="flex">{t("subscription.Find answers")}</span>
                      <div className="inline-block align-top min-w-max child:h-6 child:w-6 dark:cssvar-secondary-to-off-white ml-2 cssvar-secondary-to-white dark:group-hover/button:cssvar-secondary-to-off-black dark:group-hover/parent:cssvar-secondary-to-off-black">
                        <svg width="32" height="32" viewBox="0 0 32 32">
                          <g fill="none" fillRule="evenodd">
                            <path
                              d="m22.126 16-7.647-7.647a1.207 1.207 0 0 0-1.705 0l-.42.42a1.204 1.204 0 0 0 0 1.705L17.876 16l-5.522 5.522a1.203 1.203 0 0 0 0 1.704l.42.422c.47.47 1.235.469 1.705-.002L22.126 16z"
                              fill="var(--svg-color-secondary, #fff)"
                            ></path>
                          </g>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>

          <div className="pt-8 md:pt-12 2xl:pt-12 xl:pb-24 pb-12 2xl:pb-24">
            <div className="overflow-hidden rounded bg-white p-6 shadow dark:bg-off-black-desat dark:shadow-dark 2xs:rounded-lg mx-auto flex max-w-3xl flex-col items-center md:p-8 2xl:p-16">
              <div className="inline-flex items-center justify-center rounded-full primary-borber border bg-white p-1 dark:bg-off-white mb-6 border-info dark:border-info">
                <div className="inline-block align-top child:h-8 child:w-8 2xl:child:h-10 2xl:child:w-10">
                  <svg
                    width="32px"
                    height="32px"
                    viewBox="0 0 32 32"
                    version="1.1"
                  >
                    <title>icon/actions_info</title>
                    <g
                      id="icon/actions_info"
                      stroke="none"
                      strokeWidth="1"
                      fill="EE7214"
                      fillRule="evenodd"
                    >
                      <path
                        d="M15.0627781,13.2833484 C14.2292216,13.2833484 13.4095577,13.2833484 12.5843367,13.2833484 C12.4040026,13.2849033 12.2246588,13.3085077 12.0508606,13.3535621 C11.8387141,13.3950229 11.676741,13.5559636 11.6451964,13.7566407 C11.5865132,13.9746677 11.7037133,14.2006319 11.9230486,14.2923451 C12.190053,14.4092135 12.476874,14.4813856 12.7704977,14.5055866 C13.5429267,14.5393932 13.8541211,14.8566551 13.7374232,15.6004 C13.5206985,16.9916712 13.2289538,18.3725403 12.9788868,19.7612109 C12.809397,20.6973934 12.6848928,21.2550492 12.5843367,22.2403035 C12.4530963,23.5262052 13.2109841,24.7401952 14.1368811,25.0131061 C15.0627781,25.286017 15.724825,25.286017 16.3214484,25.2794864 C17.5999796,25.2780159 18.8212793,24.7831633 19.6973522,23.9116198 C19.8564682,23.7743898 19.9759403,23.6017433 20.0446674,23.409722 C20.0782267,23.2419815 20.0359721,23.0687264 19.9279695,22.9312287 C19.7974575,22.8547704 19.6367149,22.8384803 19.4917416,22.8870201 C19.2639028,22.9572338 19.0610707,23.1028622 18.838789,23.1938799 C18.5790019,23.3073326 18.3070186,23.3945099 18.0274607,23.4539306 C17.8020089,23.5057029 17.5636393,23.4622801 17.3753928,23.335146 C17.1871463,23.2080119 17.0679843,23.0099721 17.0494211,22.7934019 C17.0026623,22.551429 16.9942363,22.3043299 17.0244144,22.0600589 C17.1188841,21.4567414 17.2522531,20.8586248 17.3689511,20.2605082 C17.6857025,18.6291236 18.0070849,16.9968722 18.3330981,15.3637539 C18.4220108,14.9164667 18.5720509,14.4769811 18.4720242,14.0062893 C18.4564927,13.79721 18.3517318,13.6027725 18.1813424,13.4667803 C18.010953,13.3307881 17.7892668,13.2646798 17.5662261,13.2833484 C16.7326696,13.2833484 15.8963346,13.2833484 15.0627781,13.2833484 Z"
                        id="Path"
                        fill="var(--svg-color-secondary, #EE7214)"
                      ></path>
                      <path
                        d="M16.5742939,6.28268183 C15.5498224,6.23775316 14.6000794,6.81738803 14.1716262,7.74904688 C13.743173,8.68070573 13.9212618,9.77901022 14.6221567,10.5275466 C15.3230516,11.276083 16.4072909,11.52591 17.3650741,11.159561 C18.3228574,10.793212 18.9636082,9.88358197 18.9860507,8.85837141 C19.0250803,7.48444098 17.9479291,6.33655519 16.5742939,6.28823887 L16.5742939,6.28268183 Z"
                        id="Path"
                        fill="var(--svg-color-secondary, #EE7214)"
                      ></path>
                    </g>
                  </svg>
                </div>
              </div>
              <p className="whitespace-pre-line text-center text-lg md:text-xl mb-5">
                {t("subscription.GTC for our Camper Subscription")}
              </p>
              <a
                className="w-100 group/button disabled:opacity-50 border border-transparent rounded text-md text-white dark:text-off-white bg-primary dark:bg-primary-dark p-3 hover:bg-secondary group-hover/parent:bg-secondary dark:hover:text-off-black dark:group-hover/parent:text-off-black dark:hover:bg-off-white dark:group-hover/parent:bg-off-white transition-all shadow dark:shadow-dark hover:shadow-elevated dark:hover:shadow-dark-elevated pl-3 py-2 inline-block"
                href="/gtc"
              // href="https://cms.camperboys.com/pdf-files/equipment_vw_t6_1_california_ocean_editionen-1.pdf"
              >
                <div className="flex h-full items-center justify-between">
                  <div className="inline-block align-top mr-2 rounded-full bg-white p-1 child:h-7 child:w-7 dark:bg-off-white">
                    <svg
                      width="32px"
                      height="32px"
                      viewBox="0 0 32 32"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <title>icon_actions_list</title>
                      <g
                        id="icon_actions_list"
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                      >
                        <g
                          id="noun-list-1015747"
                          transform="translate(7.000000, 7.600000)"
                          fill="var(--svg-color-secondary, #163435)"
                        >
                          <path
                            d="M3.57142149e-05,15.0000417 C3.57142149e-05,14.5226498 0.189628195,14.0647578 0.527248954,13.7271513 C0.864858998,13.3896806 1.32260452,13.1999381 1.79999643,13.1999381 C2.27738834,13.1999381 2.73528029,13.3896699 3.07288676,13.7271513 C3.41035752,14.0647614 3.6001,14.522614 3.6001,15.0000417 C3.6001,15.4774336 3.41036823,15.9353255 3.07288676,16.2727891 C2.73527672,16.6103992 2.27742405,16.8000024 1.79999643,16.8000024 C1.32260452,16.8000024 0.864855427,16.6104099 0.527248954,16.2727891 C0.189638909,15.9353184 3.57142149e-05,15.4774336 3.57142149e-05,15.0000417 L3.57142149e-05,15.0000417 Z M1.79996071,3.60006429 C2.27735262,3.60006429 2.73524457,3.41033252 3.07285105,3.07285105 C3.4103218,2.735241 3.60006429,2.27738834 3.60006429,1.79996071 C3.60006429,1.3225688 3.41033252,0.864676856 3.07285105,0.52721324 C2.735241,0.189603195 2.27738834,0 1.79996071,0 C1.3225688,0 0.864819713,0.189592481 0.52721324,0.52721324 C0.189603195,0.864683999 0,1.3225688 0,1.79996071 C0,2.27735262 0.189592481,2.73524457 0.52721324,3.07285105 C0.864823284,3.4103218 1.3225688,3.60006429 1.79996071,3.60006429 Z M1.79996071,10.2000512 L1.79996071,10.1999117 C2.27735262,10.1999117 2.73524457,10.0103192 3.07285105,9.67269845 C3.4103218,9.33522769 3.60006429,8.87734289 3.60006429,8.39995098 C3.60006429,7.92255907 3.41033252,7.46466712 3.07285105,7.1272035 C2.735241,6.78959346 2.27738834,6.59999026 1.79996071,6.59999026 C1.3225688,6.59999026 0.864819713,6.78958274 0.52721324,7.1272035 C0.189603195,7.46467426 0,7.92255907 0,8.39995098 C0,8.87734289 0.189592481,9.33523483 0.52721324,9.67269845 C0.864823284,10.0103085 1.3225688,10.1999117 1.79996071,10.1999117 L1.79996071,10.2000512 Z M7.79994881,3.00006548 L16.799931,3.00006548 C17.2286444,3.00006548 17.6248579,2.77127307 17.839286,2.40003095 C18.0535713,2.02878169 18.0535713,1.57135403 17.839286,1.1999619 C17.6248615,0.828712641 17.2286444,0.600070238 16.799931,0.600070238 L7.79994881,0.600070238 C7.37123537,0.600070238 6.97516473,0.828723356 6.76073659,1.1999619 C6.5464513,1.57131831 6.5464513,2.02878169 6.76073659,2.40003095 C6.97516116,2.77128022 7.37123537,3.00006548 7.79994881,3.00006548 Z M7.79994881,9.60005238 L16.799931,9.60005238 C17.2286444,9.60005238 17.6248579,9.37125998 17.839286,9.00001786 C18.0535713,8.62866145 18.0535713,8.17134093 17.839286,7.79994881 C17.6248615,7.42869955 17.2286444,7.19991429 16.799931,7.19991429 L7.79994881,7.19991429 C7.37123537,7.19991429 6.97516473,7.42870669 6.76073659,7.79994881 C6.5464513,8.17130522 6.5464513,8.62862574 6.76073659,9.00001786 C6.97516116,9.37126712 7.37123537,9.60005238 7.79994881,9.60005238 Z M7.79994881,16.2000393 L16.799931,16.1998998 C17.2286444,16.1998998 17.6248579,15.9712467 17.839286,15.6000081 C18.0535713,15.2286517 18.0535713,14.7711883 17.839286,14.3999391 C17.6248615,14.0286898 17.2286444,13.7999045 16.799931,13.7999045 L7.79994881,13.7999045 C7.37123537,13.7999045 6.97516473,14.028697 6.76073659,14.3999391 C6.5464513,14.7711883 6.5464513,15.228616 6.76073659,15.6000081 C6.97516116,15.9712574 7.37123537,16.1998998 7.79994881,16.1998998 L7.79994881,16.2000393 Z"
                            id="Combined-Shape"
                          ></path>
                        </g>
                      </g>
                    </svg>
                  </div>
                  <span className="flex">{t("subscription.To Terms & Conditions")}</span>
                  <div className="inline-block align-top min-w-max child:h-6 child:w-6 dark:cssvar-secondary-to-off-white ml-2 cssvar-secondary-to-white dark:group-hover/button:cssvar-secondary-to-off-black dark:group-hover/parent:cssvar-secondary-to-off-black">
                    <svg width="32" height="32" viewBox="0 0 32 32">
                      <g fill="none" fillRule="evenodd">
                        <path
                          d="m22.126 16-7.647-7.647a1.207 1.207 0 0 0-1.705 0l-.42.42a1.204 1.204 0 0 0 0 1.705L17.876 16l-5.522 5.522a1.203 1.203 0 0 0 0 1.704l.42.422c.47.47 1.235.469 1.705-.002L22.126 16z"
                          fill="var(--svg-color-secondary, #163435)"
                        ></path>
                      </g>
                    </svg>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Campersubscription;

